/* eslint-disable max-len */

import React from 'react'

export default ({ className, height = 2, width = 12 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    x='0px'
    y='0px'
    viewBox='0 0 12 2'
    xmlSpace='preserve'>
    <path
      fill='#fff'
      id='path'
      d='M0.5,0h11C11.8,0,12,0.2,12,0.5v1C12,1.8,11.8,2,11.5,2h-11C0.2,2,0,1.8,0,1.5v-1C0,0.2,0.2,0,0.5,0z'
    />
  </svg>
)
